var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-breadcrumb-container"},_vm._l((_vm.breadcrumbs),function(item,i){return _c('span',{key:i,class:{
      'admin-breadcrumb-active': item.active,
      'admin-breadcrumb-has-link': item.link ? true : false,
    },on:{"click":function($event){return _vm.move(item)}}},[_vm._v("\n    "+_vm._s(_vm.checkName(item.name))+"\n    "),(i != _vm.breadcrumbs.length - 1)?_c('span',[_vm._v("/")]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }